import NewTabIcon from '~/components/icons/NewTabIcon';

import styles from './index.style';

function HubspotObjectLink({ classes, path }) {
  return (
    <a
      href={`https://app.hubspot.com/${path}`}
      rel="noopener noreferrer"
      target="_blank"
      className={classes.container}>
      <span className={classes.title}>View on Hubspot</span>
      <NewTabIcon width={12} height={12} />
    </a>
  );
}

HubspotObjectLink.propTypes = {
  path: PropTypes.string.isRequired,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(HubspotObjectLink);
